import { useNavigate } from "react-router-dom";
import "./library.css";
import { track } from "@amplitude/analytics-browser";
export const BooksPlaceHolder = () => {
  const navigate = useNavigate();
  return (
    <div
      className="libraryItem"
      onClick={() => {
        track("Home: Add new book");
        navigate("/addBook");
      }}
    >
      <div className="libraryImageContainer">
        <div
          className="libraryImageBook"
          style={{
            // fontSize: "3rem",
            // padding: "5px",
            color: "#555",
            backgroundColor: "#dedede",
            // width: "30vw",
            // maxWidth: "100px",
            // height: "160px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "3rem" }}>+</span>
          <br />
          Add new book
        </div>
      </div>
      {/* <div className="libraryTitle"> Empty</div> */}
    </div>
  );
};
